module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_bg_sp-0e34e3b2511406917b0d2b2b62e6508e.png";